import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

// User-facing preferences that persist while the user navigates the plans
// surface: which periodicity they want to see prices in (monthly vs yearly).

export interface PlansPreferencesState {
	isYearly: boolean;
}

const initialState: PlansPreferencesState = {
	isYearly: false,
};

export const plansPreferencesSlice = createSlice({
	name: 'plansPreferences',
	initialState,
	reducers: {
		setIsYearly: (state, action: PayloadAction<boolean>) => {
			state.isYearly = action.payload;
		},
	},
});

export const { setIsYearly } = plansPreferencesSlice.actions;

export default plansPreferencesSlice.reducer;
